<template>
    <div class='tep-label-only'>
        <div v-html='`${props.meta.title}:`'></div>
    </div>
</template>

<script setup>
const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    }
});
</script>

<style scoped>
.tep-label-only {
    color: rgba(117,117,117);
    font-size: 14px;
    cursor: default;
    display: flex;
    align-items: center;
}
</style>
